import React, { useState /* , useCallback */ } from 'react';
import styles from './index.module.less';
import {
  Radio,
  Button,
  Row,
  Col,
  Card,
  Empty,
  Tooltip,
  Tag
  // Popconfirm,
  // Space
} from 'antd';
//import plus from '../../images/plus.svg';
import SearchBar from '@/common/Content/searchBar';
import CustomTable from 'common/Content/CustomTable';
import {
  // EditOutlined,
  ArrowLeftOutlined,
  PlusOutlined
} from '@ant-design/icons';
import { history } from 'app/history';
//import LocalStorage from 'utilities/localStorage';
import AllExportReports from '../reports/AllExportReports';

const filters = [
  /*  {
    name: 'Gift Received',
    value: ''
  },
  {
    name: 'Pending',
    value: 'pending'
  },
  {
    name: 'Accepted',
    value: 'accepted'
  },
  {
    name: 'Rejected',
    value: 'rejected'
  } */
];

function ProjectSiteFlowPage({
  radiofilter,
  setRadiofilter,
  setTriggerFilter,
  page,
  setPage,
  pageSize,
  setPageSize,
  setSearchRequest,
  // projectSites,
  // projectSitesLoading,
  // paginationProjectSites,
  adminProjectSites,
  adminProjectSitesLoading,
  adminPaginationProjectSites
}) {
  // Map project sites data for table display
  const projectSitesList = adminProjectSites?.map((item) => {
    const siteNameRaw = item?.name || 'N/A';
    const siteName =
      siteNameRaw !== 'N/A' && siteNameRaw
        ? siteNameRaw.charAt(0).toUpperCase() + siteNameRaw.slice(1)
        : siteNameRaw;
    const incharge = item?.Incharge || null;
    const projectHeadName =
      incharge?.givenName && incharge?.surname
        ? `${incharge.givenName} ${incharge.surname}`
        : incharge?.name || incharge?.userName || 'N/A';
    const projectHeadEmail = incharge?.email || 'N/A';

    return {
      key: item?.id,
      id: item?.id,
      projectSiteName: siteName,
      projectHeadName: projectHeadName,
      projectHeadEmail: projectHeadEmail,
      buName: item?.BuMaster?.buName,
      status:
        item?.isActive !== undefined
          ? item?.isActive
          : item?.status !== undefined
          ? item?.status
          : true
    };
  });
  console.log('projectSitesList', projectSitesList);
  // const handleBU_record = (record) => {
  //   console.log('RRRRRRRRR@@@@@@@@@@', record);
  //   history.push(`edit-roUsers-flow/${record.id}`);
  //   LocalStorage.setItem('roUsers_record', JSON.stringify(record));
  // };

  const [isAllExortModalOpen, setAllExortModalOpen] = useState(false);

  const columns = [
    {
      title: 'Project Site Name',
      dataIndex: 'projectSiteName',
      key: 'projectSiteName',
      // width: 400,
      ellipsis: true,
      // sorter: (a, b) => a.ticket - b.ticket,
      sorter: (a, b) => a?.projectSiteName?.localeCompare(b?.projectSiteName),
      render: (projectSiteName) => {
        return (
          <>
            <Tooltip
              title={projectSiteName}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {projectSiteName === null || projectSiteName === ''
                ? 'N/A'
                : projectSiteName}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Project Manager',
      dataIndex: 'projectHeadName',
      key: 'projectHeadName',
      // width: 400,
      ellipsis: true,
      // sorter: (a, b) => a.ticket - b.ticket,
      sorter: (a, b) => a?.projectHeadName?.localeCompare(b?.projectHeadName),
      render: (projectHeadName) => {
        return (
          <>
            <Tooltip
              title={projectHeadName}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              {projectHeadName === null || projectHeadName === ''
                ? 'N/A'
                : projectHeadName}
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'Email',
      dataIndex: 'projectHeadEmail',
      key: 'projectHeadEmail',
      ellipsis: {
        showTitle: false
      },
      sorter: (a, b) => a?.projectHeadEmail?.localeCompare(b?.projectHeadEmail),
      render: (projectHeadEmail) => {
        return (
          <>
            <Tooltip
              title={projectHeadEmail}
              color={'white'}
              overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
              arrowPointAtCenter="false"
            >
              <span className={styles.text_transform}>
                {projectHeadEmail === null || projectHeadEmail === ''
                  ? 'N/A'
                  : projectHeadEmail}
              </span>
            </Tooltip>
          </>
        );
      }
    },
    {
      title: 'BU Name',
      dataIndex: 'buName',
      key: 'buName',
      ellipsis: true,
      sorter: (a, b) => a?.buName?.localeCompare(b?.buName),
      render: (buName) => {
        return (
          <Tooltip
            title={buName}
            color={'white'}
            overlayInnerStyle={{ color: '#32324D', fontSize: '12px' }}
            arrowPointAtCenter="false"
          >
            <span>
              {buName === null || buName === '' || buName === undefined
                ? 'NA'
                : buName}
            </span>
          </Tooltip>
        );
      }
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      //width: '120px',
      ellipsis: true,
      //sorter: (a, b) => a?.status?.localeCompare(b?.status),
      render: (status, record) => (
        <Tag
          className={`${styles.status_style}`}
          color={
            record?.status === true
              ? 'green'
              : record?.status === false
              ? 'red'
              : 'transparent'
          }
        >
          {record?.status === true ? 'ACTIVE' : 'DEACTIVATED'}
        </Tag>
      )
    }
    /*  {
      title: 'Action',
      key: '',
      width: 180,
      render: (record) => (
        <>
          <Space size="middle">
            <>
              <EditOutlined
                className={`${styles.edit_bu}`}
                onClick={() => handleBU_record(record)}
              />
              <Popconfirm
                placement="top"
                title="Are you sure you want to deactivate this RO mapping?"
                visible={visibility(record)}
                onConfirm={() => {
                  handleDeleteRequest({
                    record: record
                  });
                }}
                onCancel={() => {
                  setShowDisablePopup({});
                }}
                okText="Deactivate"
                cancelText="No"
                okButtonProps={{ type: 'danger' }}
              >
                <a
                  className={`${styles.allocation_btn}`}
                  style={{
                    fontSize: '12px'
                  }}
                  type="link"
                  disabled={record?.status === false}
                >
                  Deactivate
                </a>
              </Popconfirm>
            </>
          </Space>
        </>
      )
    } */
  ];

  // const visibility = useCallback((record) => {
  //   return showDisablePopup[record.id];
  // }, showDisablePopup);

  let locale = {
    emptyText: (
      <span>
        <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
        <div className={styles.empty_state_text}>
          There are no Project Sites to display
        </div>
      </span>
    )
  };

  return (
    <>
      <div className={`${styles.container}`}>
        <Row className={`${styles.row_container}`}>
          <div className={`${styles.gift_container}`}>
            <div className={`${styles.myGift_title}`}>
              Configure Project Sites
            </div>
            <div className={`${styles.myGift_text}`}>
              View and manage project sites
            </div>
          </div>

          <Row>
            <Button
              className={`${styles.export_button}`}
              onClick={() => setAllExortModalOpen(true)}
            >
              Export
            </Button>
            <Button
              className={`${styles.declareGift_button}`}
              icon={<PlusOutlined />}
              onClick={() => history.push('/create-project-site-flow')}
            >
              Add Project Site
            </Button>
            <Button
              style={{ marginLeft: '20px' }}
              className={`${styles.declareGift_button}`}
              icon={<ArrowLeftOutlined />}
              onClick={() => history.push('/admin')}
            >
              Back
            </Button>
          </Row>
        </Row>
        <div className={`${styles.tabs_container}`}>
          <Row>
            {/* className={`${styles.row_container}`} */}
            <Col span={16}>
              <Radio.Group
                value={radiofilter}
                size="small"
                className={`${styles.button_import_style}`}
              >
                {filters.map((item, index) => {
                  return (
                    <Radio.Button
                      value={item.value}
                      key={index}
                      //className={`${styles.RadioButton_import_style}`}
                      onChange={() => {
                        window.localStorage.setItem(
                          'set_Radiofilter',
                          JSON?.stringify(item.value)
                        );
                        setRadiofilter(item.value);
                        setTriggerFilter(true);
                      }}
                    >
                      {item.name}
                    </Radio.Button>
                  );
                })}
              </Radio.Group>
            </Col>
            <Col span={8}>
              <SearchBar
                onChange={(e) => {
                  setSearchRequest(e.target.value);
                  setTriggerFilter(true);
                }}
                className={` ${styles.searchbar}`}
                inputProps={{
                  placeholder: 'Search by project site name'
                }}
              />
            </Col>
          </Row>
        </div>
        <Card className={`${styles.cardStyles}`}>
          <div className={`${styles.table_container}`}>
            <CustomTable
              columns={columns}
              dataSource={projectSitesList || []}
              locale={locale}
              loading={adminProjectSitesLoading}
              pagination={{
                current: page,
                pageSize: pageSize,
                showSizeChanger: true,
                size: 'small',
                total: adminPaginationProjectSites?.total_records || 0,
                onChange: (page, pageSize) => {
                  setPage(page);
                  setPageSize(pageSize);
                }
              }}
            />
          </div>
        </Card>
        {isAllExortModalOpen ? (
          <AllExportReports
            isAllExortModalOpen={isAllExortModalOpen}
            setAllExortModalOpen={setAllExortModalOpen}
            apiName={'project_sites_master'}
          />
        ) : (
          ''
        )}
      </div>
    </>
  );
}
export default ProjectSiteFlowPage;
